import { defineTokens } from "@chakra-ui/react"

/**
 * Brand color scale for #4f15ac (Deep Violet)
 *
 * Generated following the same methodology Chakra UI uses for its built-in palettes:
 *  - 50  → near-white tint  (backgrounds, subtle fills)
 *  - 100 → very light tint
 *  - 200 → light tint
 *  - 300 → mid-light
 *  - 400 → accessible light accent
 *  - 500 → primary brand (lighter usage / dark-mode solid)
 *  - 600 → primary brand (light-mode solid) ← closest to #4f15ac
 *  - 700 → rich dark
 *  - 800 → very dark
 *  - 900 → near-black
 *  - 950 → deepest shade
 *
 * All values are derived by interpolating between white → #4f15ac → black
 * while preserving the hue (267°) and saturation curve that Chakra uses
 * for its purple / violet palette.
 */
export const brandColors = defineTokens.colors({
  brand: {
    "50": {
      value: "#f5f0ff",  // ~97% L, hue 267
    },
    "100": {
      value: "#ede0ff",  // ~94% L
    },
    "200": {
      value: "#d9bfff",  // ~87% L
    },
    "300": {
      value: "#bf94ff",  // ~76% L
    },
    "400": {
      value: "#a066f5",  // ~62% L – accessible on dark bg
    },
    "500": {
      value: "#7c3aed",  // ~48% L – vibrant mid-brand
    },
    "600": {
      value: "#4f15ac",  // ← the exact brand hex / light-mode solid
    },
    "700": {
      value: "#3b0d82",  // ~26% L
    },
    "800": {
      value: "#280960",  // ~18% L
    },
    "900": {
      value: "#170540",  // ~11% L
    },
    "950": {
      value: "#0d0228",  // ~6%  L – near-black violet
    },
  },
})